import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/modal'
import '@/lib/debug'
import '@/lib/ble'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
//
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faThermometerHalf,
  faHeartbeat,
  faChartLine,
  faToggleOn,
  faToggleOff,
  faCalendarAlt,
  faClock,
  faBolt,
  faRedo,
  faTint,
  faWater,
  faStethoscope,
  faLink,
  faUnlink,
  faSpinner,
  faSortDown,
  faClipboardCheck,
  faCogs,
  faChevronLeft,
  faTimes,
  faChevronDown,
  faChevronUp
} from '@fortawesome/free-solid-svg-icons'
import {
  faHeartRate,
  faTachometer,
  faOilTemp,
  faOilCan,
  faCommentAltExclamation
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faThermometerHalf,
  faHeartbeat,
  faChartLine,
  faToggleOn,
  faToggleOff,
  faHeartRate,
  faTachometer,
  faCalendarAlt,
  faClock,
  faBolt,
  faRedo,
  faTint,
  faWater,
  faOilTemp,
  faOilCan,
  faCommentAltExclamation,
  faStethoscope,
  faLink,
  faUnlink,
  faSpinner,
  faSortDown,
  faClipboardCheck,
  faCogs,
  faChevronLeft,
  faTimes,
  faChevronDown,
  faChevronUp
)

Vue.component('fa-icon', FontAwesomeIcon)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js